<ng-container *transloco="let t">
  @if (loaded) {
    <div style="height: 100vh; overflow: auto; padding: 7px;" [style.font-family]="themeConfig.bgAndFontColor.default.font + ' !important'" [style.background]="setHeaderBackground(90, themeConfig.bgAndFontColor.default.bg[0], themeConfig.bgAndFontColor.default.bg[0])" [style.background-color]="themeConfig.bgAndFontColor.default.bg[0]">
      <div class="grid grid-cols-12 gap-3 flex items-center desktop">
        <div class="md:col-span-1 lg:col-span-3 xl:col-span-4 col-span-12"></div>
        <div class="md:col-span-10 lg:col-span-6 xl:col-span-4 col-span-12">
          <div class="grid grid-cols-12 gap-3 main-box-box w-full">
            <div class="col-span-12 pd-0">
              <div class="w-full" style="background-color: #fff; padding: 8px 0px;">
                <h6 style="margin:3px 10px 0px;">
                  <span class="ml-2" [style.color]="themeConfig.bgAndFontColor.default.primary + '!important'"
                    [style.font-family]="themeConfig.bgAndFontColor.default.font + ' !important'">{{
                  t('signUpComponent.signUpConfirmation') }}</span>
                </h6>
              </div>
              <div class="w-full signup-confirmation-container mt-1">
                <div class="w-full" style="min-height: 45px;">
                  <h5
                    style="font-size: 19px; font-weight: bolder; margin-top: 12px; padding-bottom: 15px; border-bottom: 2px solid #e9ecef; color: #212529 !important;">
                    <i class="fa fa-check-circle" aria-hidden="true"
                      style="font-size: 25px; margin-right: 10px; vertical-align: middle;"
                    [style.color]="themeConfig.bgAndFontColor.default.primary + '!important'"></i>
                    {{ t('signUpComponent.thanksForSignUp') }}
                  </h5>
                </div>
                <div class="grid grid-cols-1 pb-3">
                  <div class="w-full mt-3">
                    <p style="color: black; font-size: 17px; font-weight: 800;">{{ t('signUpComponent.details') }}</p>
                  </div>
                  <table class="tis-table table w-full mt-3">
                    <tbody>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.fullName') }} :</td>
                        <td>{{userDetails?.name }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.userName') }} :</td>
                        <td>{{userDetails?.userName }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.email') }} :</td>
                        <td matTooltip="{{userDetails?.email }}" matTooltipPosition="above"
                        style="min-width: 150px; max-width: 158px;word-wrap: break-word;">{{userDetails?.email }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.mobile') }} :</td>
                        <td>{{userDetails?.mobileNo }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.gender') }} :</td>
                        <td>{{userDetails?.gender }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.company') }} :</td>
                        <td>{{userDetails?.companyName }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.project') }} :</td>
                        <td>{{userDetails?.projectName }}</td>
                      </tr>
                      <tr>
                        <td class="white-space">{{ t('signUpComponent.building') }} :</td>
                        <td>{{userDetails?.buldingDescription }}</td>
                      </tr>
                      <!--<tr>
                      <td class="white-space">{{ t('signUpComponent.floorNo') }} :</td>
                      <td>{{userDetails?.floorDescription }}</td>
                    </tr> -->
                    <tr>
                      <td class="white-space">{{ t('signUpComponent.unitNo') }} :</td>
                      <td>{{userDetails?.unitNumber }}</td>
                    </tr>
                    <tr>
                      <td class="white-space">{{ t('signUpComponent.signUpDate') }} :</td>
                      <td>{{userDetails?.createdAt | date:'medium' }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="w-full mt-2 mb-2">
                  <p style="color: red;">{{ t('signUpComponent.youAccountPending') }}</p>
                </div>
                <div class="w-full text-center mt-4">
                  <button mat-raised-button class="t-bg" style="height: 35px !important;" (click)="loginPage();"
                    [style.background]="setHeaderBackground(90, themeConfig.bgAndFontColor.default.primaryBtn.bg[0], themeConfig.bgAndFontColor.default.primaryBtn.bg[0])"
                    [style.background-color]="themeConfig.bgAndFontColor.default.primaryBtn.bg[0]"
                    [style.color]="themeConfig.bgAndFontColor.default.primaryBtn.text"
                    [style.font-family]="themeConfig.bgAndFontColor.default.font + '!important'">
                    {{ t('signUpComponent.visitHomePage') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md:col-span-1 lg:col-span-3 xl:col-span-4 col-span-12"></div>
    </div>
  </div>
}
</ng-container>